import React from "react";
var __jsx = React.createElement;
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { EncounterRecordRow } from "./encounter-record-row";
import { useInfiniteScroll } from "./use-infinite-scroll";
var TH = "sticky top-0 z-sds-100 bg-sds-base-secondary px-4 py-2.5 text-left text-style-label-caps text-sds-base-secondary";

/** Columnar table of encounters with a sticky header and infinite scroll. */
export function EncountersTable(_ref) {
  var rows = _ref.rows,
    totalCount = _ref.totalCount,
    onOpenDocument = _ref.onOpenDocument,
    isOpening = _ref.isOpening,
    hasMore = _ref.hasMore,
    isLoadingMore = _ref.isLoadingMore,
    onLoadMore = _ref.onLoadMore,
    onAddNote = _ref.onAddNote;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var scrollRef = useRef(null);
  var sentinelRef = useInfiniteScroll({
    rootRef: scrollRef,
    hasMore: hasMore,
    isLoading: isLoadingMore,
    onLoadMore: onLoadMore
  });
  var headers = [{
    key: "expand",
    labelKey: "",
    tagKey: ""
  }, {
    key: "encounter",
    labelKey: "encounter",
    tagKey: "date_time"
  }, {
    key: "reason",
    labelKey: "reason",
    tagKey: ""
  }, {
    key: "provider",
    labelKey: "provider",
    tagKey: ""
  }, {
    key: "location",
    labelKey: "location",
    tagKey: ""
  }, {
    key: "docs",
    labelKey: "docs",
    tagKey: ""
  }, {
    key: "actions",
    labelKey: "",
    tagKey: ""
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-full flex-col overflow-hidden rounded-sds-300 border border-sds-base-default bg-sds-base-default"
  }, /*#__PURE__*/React.createElement("div", {
    ref: scrollRef,
    className: "min-h-0 flex-1 overflow-auto scrollbar-sds"
  }, /*#__PURE__*/React.createElement("table", {
    className: "w-full min-w-[1040px] table-fixed"
  }, /*#__PURE__*/React.createElement("colgroup", null, /*#__PURE__*/React.createElement("col", {
    className: "w-[4%]"
  }), /*#__PURE__*/React.createElement("col", {
    className: "w-[24%]"
  }), /*#__PURE__*/React.createElement("col", {
    className: "w-[18%]"
  }), /*#__PURE__*/React.createElement("col", {
    className: "w-[18%]"
  }), /*#__PURE__*/React.createElement("col", {
    className: "w-[22%]"
  }), /*#__PURE__*/React.createElement("col", {
    className: "w-[8%]"
  }), /*#__PURE__*/React.createElement("col", {
    className: "w-[6%]"
  })), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, headers.map(function (header) {
    return /*#__PURE__*/React.createElement("th", {
      key: header.key,
      scope: "col",
      className: TH
    }, header.labelKey ? t(header.labelKey) : "", header.tagKey ? /*#__PURE__*/React.createElement("span", {
      className: "ml-2 rounded-sds-full bg-sds-base-tertiary px-2 py-0.5 text-style-label-emphasis text-sds-base-secondary"
    }, t(header.tagKey)) : null);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (encounter) {
    return /*#__PURE__*/React.createElement(EncounterRecordRow, {
      key: encounter.fhir_id,
      encounter: encounter,
      onOpenDocument: onOpenDocument,
      isOpening: isOpening,
      onAddNote: onAddNote
    });
  }))), /*#__PURE__*/React.createElement("div", {
    ref: sentinelRef
  }), isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center gap-2 py-4 text-style-label-base text-sds-base-tertiary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    className: "h-3.5 w-3.5 animate-spin"
  }), t("loading_more", {
    defaultValue: "Loading more…"
  })) : null), /*#__PURE__*/React.createElement("p", {
    className: "border-t border-sds-base-default px-5 py-3 text-style-label-base text-sds-base-tertiary"
  }, t("showing_encounters", {
    count: rows.length,
    total: totalCount
  })));
}